import { getS } from "../../core/state";

const normalizeOpt = (opt) => {
  if (opt && typeof opt === "object" && opt.value !== undefined && opt.value !== null) {
    const v = String(opt.value).trim();
    const lab = String(opt.label ?? opt.value ?? "").trim() || v;
    return v ? { value: v, label: lab } : null;
  }
  const s = String(opt ?? "").trim();
  return s ? { value: s, label: s } : null;
};

export default function Dropdown({ value, onChange, options, optionsKey, label, showAllOption = true }) {
  const s = getS();
  const rawOptions = optionsKey ? s.dynamicOptions?.[optionsKey] || [] : options || [];
  const seen = new Set();
  const finalOptions = rawOptions
    .map(normalizeOpt)
    .filter(Boolean)
    .filter((opt) => {
      if (opt.value.toLowerCase() === "all") return false;
      const key = opt.value.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

  return (
    <select className="lfx-select" value={value ?? ""} onChange={(e) => onChange(e.target.value)}>
      {showAllOption ? <option value="">All</option> : <option value="">Select…</option>}
      {finalOptions.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
